<div class="container-fluid bg-white">

  <app-loader *ngIf="isLoading()"></app-loader>

  <div class="page" *ngIf="!isLoading()">

    <div class="page-body">

      <div class="container-section">

        <div class="container-smaller">

          <div class="content-wrapper">

            <div class="content">

              <div class="entity-single">

                <div class="d-block mb-3 text-right justify-content-end align-items-end" *ngIf="entity && entity.meetDayId && (isStudentLoggedIn() || isGuest())">
                  <a class="btn btn-primary btn-lg d-block d-lg-inline-block" [href]="window.location.href.replace('#meet-day-signup', '') + '#meet-day-signup'">
                    {{ 'Signup for event' | translate }}
                    <fa-icon class="ml-1" [icon]="faPencil"></fa-icon>
                  </a>
                </div>

                <div class="row">

                  <div class="col-12 col-sm-7 column-left">

                    <h1 class="page-title entity-title alternate-heading">
                      {{getTranslatedTitle(entity)}}
                    </h1>

                    <h3 class="font-weight-bold" *ngIf="entity.eventDate"><br/> {{entity.eventDate | date: 'dd-MM-YY'}}</h3>

                    <div class="entity-content" [innerHTML]="getTranslatedContent(entity) | safeHtml"></div>

                  </div>

                  <div class="col-12 col-sm-5 column-right">

                    <div class="image-main entity-image-main">
                      <img class="img-fluid" [src]="entity.imageUri" />
                    </div>

                    <!-- image gallery thumbnails -->
                    <div class="image-thumbnails-wrapper mt-3" *ngIf="entity.imageReferences && entity.imageReferences.length>0">
                      <div class="row">
                        <div class="col-sm-6 cursor-pointer" [ngClass]="{'d-none': image['imageType'] != externalpageImageTypes.GalleryImage}" *ngFor="let image of entity.imageReferences" (click)="imageService.openImage(image.imageUri, entity.title)">
                          <img class="img-fluid image-thumb" [src]="image['imageUri']" />
                        </div>
                      </div>
                    </div>

                  </div>

                </div>

              </div>

              <!-- meet day -->
              <div class="" id="meet-day-signup" *ngIf="entity && entity.meetDayId && (isStudentLoggedIn() || isGuest())">
                <app-meetday-signup [meetDayId]="entity.meetDayId"></app-meetday-signup>
              </div>


              <div class="entity-related mt-4">

                <h3 class="alternate-heading text-center mb-4">
                  <span class="text-primary">{{'More' | translate}}</span> {{'events' | translate}}
                </h3>

                <div class="grid grid-event">

                  <div class="row">

                    <div class="col-6 col-sm-4 grid-item grid-item-event grid-item-image-bg" *ngFor="let node of relatedData()">

                      <a class="grid-item-link" [routerLink]="'/events/' + (node.permalink ? node.permalink : node.id)">

                        <div class="grid-item-image-wrapper" *ngIf="node.imageUri" [ngStyle]="{'background-image' : 'url(' + (node.imageUri ? node.imageUri : '') + ''}">
                          <img class="grid-item-image grid-item-image-event img-fluid" [src]="node.imageUri" />
                        </div>

                        <h3 class="grid-item-title">
                          {{getTranslatedTitle(node)}}
                          <span class="grid-item-date text-xs" *ngIf="node.eventDate"><br/> {{node.eventDate | date: 'dd-MM-YY'}}</span>
                        </h3>
                      </a>
                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</div>

